// extracted by mini-css-extract-plugin
export default {"noteContainer":"Style_noteContainer__eYWZm","editNoteIconbtn":"Style_editNoteIconbtn__XFvss"};